/**
 * @flow
 * @relayHash c8eac9d561f7b0115ea350466faaede7
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UserWhere = {|
  and?: ?$ReadOnlyArray<?UserWhere>,
  or?: ?$ReadOnlyArray<?UserWhere>,
  id?: ?ConditionInputType,
  code?: ?ConditionInputType,
  email?: ?ConditionInputType,
  username?: ?ConditionInputType,
  name?: ?ConditionInputType,
  phone?: ?ConditionInputType,
  locationId?: ?ConditionInputType,
  dpi?: ?ConditionInputType,
  phoneCompany?: ?ConditionInputType,
  emailPersonal?: ?ConditionInputType,
  licenceType?: ?ConditionInputType,
  licenceNumber?: ?ConditionInputType,
  fechaIngreso?: ?ConditionInputType,
  contratoNumero?: ?ConditionInputType,
  puesto?: ?ConditionInputType,
  edad?: ?ConditionInputType,
  fechaNac?: ?ConditionInputType,
  direccion?: ?ConditionInputType,
  municipio?: ?ConditionInputType,
  departamentoGt?: ?ConditionInputType,
  profesion?: ?ConditionInputType,
  primerNombre?: ?ConditionInputType,
  segundoNombre?: ?ConditionInputType,
  primerApellido?: ?ConditionInputType,
  segundoApellido?: ?ConditionInputType,
  igss?: ?ConditionInputType,
  salarioBase?: ?ConditionInputType,
  bonoIncentivo?: ?ConditionInputType,
  bonoProduct?: ?ConditionInputType,
  vehiculo?: ?ConditionInputType,
  placas?: ?ConditionInputType,
  combustible?: ?ConditionInputType,
  comentarios?: ?ConditionInputType,
  isLimitedByLocation?: ?ConditionInputType,
  isDisabled?: ?ConditionInputType,
  createdAt?: ?ConditionInputType,
  createdBy?: ?ConditionInputType,
|};
export type ConditionInputType = {|
  eq?: ?string,
  ne?: ?string,
  gt?: ?string,
  gte?: ?string,
  lt?: ?string,
  lte?: ?string,
  is?: ?string,
  not?: ?string,
  in?: ?$ReadOnlyArray<?string>,
  notIn?: ?$ReadOnlyArray<?string>,
  like?: ?string,
  notLike?: ?string,
  iLike?: ?string,
  insub?: ?string,
|};
export type UserSelectQueryVariables = {|
  where?: ?UserWhere
|};
export type UserSelectQueryResponse = {|
  +users: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: string,
        +locationId: ?string,
      |}
    |}>
  |}
|};
export type UserSelectQuery = {|
  variables: UserSelectQueryVariables,
  response: UserSelectQueryResponse,
|};
*/


/*
query UserSelectQuery(
  $where: UserWhere
) {
  users(where: $where, first: 10, orderBy: [name], order: ASC) {
    edges {
      node {
        id
        name
        locationId
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "where",
    "type": "UserWhere",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "users",
    "storageKey": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 10
      },
      {
        "kind": "Literal",
        "name": "order",
        "value": "ASC"
      },
      {
        "kind": "Literal",
        "name": "orderBy",
        "value": [
          "name"
        ]
      },
      {
        "kind": "Variable",
        "name": "where",
        "variableName": "where"
      }
    ],
    "concreteType": "UserConnection",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "UserEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "locationId",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UserSelectQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UserSelectQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "UserSelectQuery",
    "id": null,
    "text": "query UserSelectQuery(\n  $where: UserWhere\n) {\n  users(where: $where, first: 10, orderBy: [name], order: ASC) {\n    edges {\n      node {\n        id\n        name\n        locationId\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1614a24668c4dc050845b32d44bb3511';
module.exports = node;
